import { capabilities } from '@/mocks/homeData';

export default function CapabilitiesSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-950">
      <div className="section-padding max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-14 md:mb-20 reveal">
          <p className="text-primary-400 text-xs font-semibold tracking-[0.25em] uppercase mb-4">
            Our Strengths
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-50 mb-4">
            What Sets Us Apart
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            Independent procurement with global reach. Not bound by restrictive dealership contracts.
          </p>
        </div>

        {/* Capabilities Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 reveal">
          {capabilities.map((cap, index) => (
            <div
              key={cap.id}
              className="group relative p-6 md:p-8 bg-background-900/60 border border-background-800/50 rounded-xl hover:border-primary-500/30 transition-all duration-500"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center bg-primary-500/10 border border-primary-500/20 rounded-lg mb-5 group-hover:bg-primary-500/20 group-hover:border-primary-500/40 transition-all duration-500">
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className={`${cap.icon} text-primary-400 text-lg`}></i>
                </span>
              </div>

              {/* Title */}
              <h3 className="text-lg font-bold text-foreground-100 mb-2 tracking-wide">
                {cap.title}
              </h3>

              {/* Subtitle */}
              <p className="text-sm font-semibold text-primary-400 mb-3">
                {cap.subtitle}
              </p>

              {/* Description */}
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cap.description}
              </p>

              {/* Hover accent line */}
              <div className="absolute bottom-0 left-6 right-6 h-px bg-primary-500/0 group-hover:bg-primary-500/40 transition-all duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}